import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle2, Book } from 'lucide-react';
export function ProductShowcase() {
  const tomos = ['Arranque desde cero', 'Reventa de iPhones', 'Productos digitales', 'Sistema de ventas', 'Tráfico y clientes', 'Escalado del negocio'];
  const includes = ['Paso a paso simple', 'Estrategias reales', 'Ejemplos claros', 'Actividades prácticas', 'Sistema listo para usar'];
  return <Section className="bg-dark-800 border-t border-dark-700" data-id="element-230">
      <div className="text-center mb-16" data-id="element-231">
        <div className="inline-block bg-dark-900 border border-gold-500/30 px-6 py-2 rounded-full mb-6" data-id="element-232">
          <span className="text-gold-400 font-bold tracking-wide uppercase" data-id="element-233">
            Todo Resuelto
          </span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6" data-id="element-234">
          🏆 MEGA PACK REVENTA PRO
        </h2>
        <p className="text-2xl text-gray-300 font-medium" data-id="element-235">6 Tomos + 6 Bonos</p>
        <p className="text-xl text-gold-400 mt-4 font-semibold" data-id="element-236">
          360+ páginas — Sistema completo paso a paso
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-237">
        <div className="relative" data-id="element-238">
          <div className="absolute inset-0 bg-gold-500/20 blur-[100px] rounded-full" data-id="element-239" />
          <img src="https://cdn.magicpatterns.com/uploads/wh5EkgtWAedsPdt6Waihh6/mockup_magiss-Paquete_MEGA_para_ganar_dinero.png" alt="Mega Pack Reventa Pro" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-240" />
        </div>

        <div data-id="element-241">
          <h3 className="text-3xl font-black text-white mb-8 flex items-center gap-3" data-id="element-242">
            <Book className="text-gold-500 w-8 h-8" data-id="element-243" />
            LOS 6 TOMOS
          </h3>

          <div className="grid sm:grid-cols-2 gap-4 mb-12" data-id="element-244">
            {tomos.map((tomo, idx) => <div key={idx} className="bg-dark-900 border border-dark-700 p-4 rounded-xl flex items-center gap-3" data-id="element-245">
                <span className="text-gold-500 font-bold text-xl" data-id="element-246">
                  0{idx + 1}.
                </span>
                <span className="text-gray-200 font-medium" data-id="element-247">{tomo}</span>
              </div>)}
          </div>

          <div className="bg-dark-900/50 border border-gold-500/20 p-8 rounded-2xl" data-id="element-248">
            <h4 className="text-2xl font-bold text-white mb-6" data-id="element-249">
              💣 CADA TOMO INCLUYE:
            </h4>
            <ul className="space-y-4" data-id="element-250">
              {includes.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-251">
                  <CheckCircle2 className="text-gold-500 w-6 h-6 shrink-0" data-id="element-252" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}